import React from "react";
import { Checkbox, Typography } from "@material-ui/core";
import { CheckBox, AccountBox, CheckBoxOutlineBlank } from "@material-ui/icons";
import { CloseBox } from "mdi-material-ui";
import WithTooltip from "@components/WithTooltip";
import { AccommodationTravelAudit, AccommodationTravelStatus } from "@graphql";
import locale from "@bonliva-crm/locale";
import { moment } from "@bonliva-crm/common";

type Props = {
  status: AccommodationTravelStatus;
  audit: AccommodationTravelAudit;
  bookingId: string;
};

export const StatusCheckbox = ({ status, audit }: Props) => {
  const Tooltip = () => {
    return (
      <div>
        <Typography variant={"subtitle2"}>{locale.Status}</Typography>
        <Typography variant={"body1"} color={"inherit"}>
          {locale.accommodationTravelStatus[status]}
          {!status && "no status"}
        </Typography>
        {audit && (
          <>
            <Typography variant={"subtitle2"}>{locale.Updated}</Typography>
            <Typography variant={"body2"} color={"inherit"}>
              {audit.setBy?.Name}
            </Typography>
            <Typography variant={"body2"} color={"inherit"}>
              {audit.setOn ? moment(audit.setOn).format("YYYY-MM-DD HH:mm") : null}
            </Typography>
          </>
        )}
      </div>
    );
  };
  return (
    <WithTooltip title={<Tooltip />}>
      <Checkbox
        checked
        icon={<CheckBoxOutlineBlank />}
        checkedIcon={getCheckboxIcon(status)}
        style={{ color: "green" }}
      />
    </WithTooltip>
  );
};

const getCheckboxIcon = (type) => {
  switch (type) {
    case AccommodationTravelStatus.Confirmed:
      return <CheckBox />;
    case AccommodationTravelStatus.Requested:
      return <CloseBox color={"error"} />;
    case AccommodationTravelStatus.Blank:
      return <AccountBox style={{ pointerEvents: "none" }} />;
    default:
      return <AccountBox style={{ pointerEvents: "none" }} />;
  }
};
